export default () => {
  const input = document.querySelector('.searching__input')
  if (input) {
    const urlParams = new URLSearchParams(window.location.search)
    input.value = urlParams.get('search')
  }
}